var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/franceconnect_button.c34d424a.png",
    width: 245,
    height: 58
});